<template>
  <el-dialog
    :visible="true"
    width="500px"
    @close="$router.replace('/users')"
    :close-on-click-modal="false"
  >
    <div
      slot="title"
    >
      {{ title }}
      <el-tag type="info" v-if="user.id === loggedInUser.id" size="small" style="margin-left: 5px;">Saját felhasználó</el-tag>
    </div>
    <el-tabs v-model="activeName" v-loading="loading">
      <el-tab-pane label="Alapadatok" name="1">
        <basic-data-view
          :user-data="user"
        />
      </el-tab-pane>
      <el-tab-pane label="HR adatok" name="3">
        <hr-data-view
          :user-data="user"
        />
      </el-tab-pane>
      <el-tab-pane label="Cim adatok" name="4">
        <address-data-view
          :user-data="user"
        />
      </el-tab-pane>
      <el-tab-pane label="Napló" name="2">
        <activity-timeline
          v-if="user && user.activities"
          :activities="user.activities"
          :propsMap="propsMap"
          :formatters="activityFormatters"
        />
      </el-tab-pane>
    </el-tabs>
    <div
      slot="footer"
      class="dialog-footer"
      v-can="['user.delete', 'user.update']"
    >
      <el-button
        @click="$router.replace('/users/update/' + user.id)"
        type="primary"
        icon="el-icon-edit"
        v-can="'user.update'"
      >
        Módosítás
      </el-button>
      <el-tooltip
        class="item"
        effect="dark"
        v-if="loggedInUser.id === user.id"
        content="Saját felhasználó törlése nem lehetséges"
        placement="top"
        v-can="'user.delete'"
      >
        <el-popover
          placement="bottom"
          width="171"
          v-model="deleteConfirmVisible"
        >
          <p>Biztosan törölni szeretnéd?</p>
          <div style="text-align: right; margin: 0">
            <el-button
              size="mini"
              type="text"
              @click="deleteConfirmVisible = false"
            >
              Mégse
            </el-button>
            <el-button
              type="danger"
              size="mini"
              @click="deleteUser()"
            >
              Törlés
            </el-button>
          </div>
          <el-button
            slot="reference"
            :loading="deleteButtonLoader"
            icon="el-icon-delete"
            type="danger"
            :disabled="loggedInUser.id === user.id"
            style="margin-left: 5px;"
          >
            Törlés
          </el-button>
        </el-popover>
      </el-tooltip>
      <el-popover
        placement="bottom"
        width="171"
        v-model="deleteConfirmVisible"
        v-if="loggedInUser.id !== user.id"
      >
        <p>Biztosan törölni szeretnéd?</p>
        <div style="text-align: right; margin: 0">
          <el-button
            size="mini"
            type="text"
            @click="deleteConfirmVisible = false"
          >
            Mégse
          </el-button>
          <el-button
            type="danger"
            size="mini"
            @click="deleteUser()"
          >
            Törlés
          </el-button>
        </div>
        <el-button
          slot="reference"
          :loading="deleteButtonLoader"
          icon="el-icon-delete"
          type="danger"
          style="margin-left: 5px;"
        >
          Törlés
        </el-button>
      </el-popover>
    </div>
  </el-dialog>
</template>

<script>
import ActivityTimeline from '../ActivityTimeline';
import BasicDataView from './views/BasicDataView';
import HrDataView from './views/HrFormView';
import AddressDataView from './views/AddressFormView';

export default {
  components: { ActivityTimeline, BasicDataView, HrDataView, AddressDataView },
  props: ['userId'],
  data() {
    return {
      activeName: '1',
      deleteButtonLoader: false,
      deleteConfirmVisible: false,
      title: 'Betöltés folyamatban...',
      loading: false,
      buttonLoading: false,
      user: {},
      userData: [],
      propsMap: {
        'last_name': 'Vezetéknév',
        'first_name': 'Keresztnév',
        'mobile': 'Mobil',
        'private_mobile': 'Privát mobil',
        'email': 'E-mail',
        'private_email': 'Privát e-mail',
        'username': 'Felhasználónév',
        'roles': 'Jogkör',
        'categories': 'Csoportok',
        'invoiceBooks': 'Számlatömbök',
        'locations': 'Területek',
        'nick_name': 'Becenév',
        'birth_name': 'Születési név',
        'birth_place': 'Születési hely',
        'birth_date': 'Születési idő',
        'id_card_number': 'Szig. szám',
        'social_insurance_number':'TB szám',
        'tax_id_number':'Adóazonosító jel',
        'tax_number':'Adószám',
        'leader_user':'Területi vezető',
        'is_active':'Aktív',
      },
      activityFormatters: {
        is_active: ia => ({
          value: ia ? 'Igen' : 'Nem'
        })
      },
    };
  },
  watch: {
    userId(newVal) {
      this.activeName = '1';
      this.fetchData();
    },
  },
  computed: {
    loggedInUser() {
      return this.$store.getters['auth/user'];
    },
  },
  async mounted() {
    await this.fetchData();
  },
  methods: {
    async fetchData() {
      this.loading = true;
      this.user = await axios.get(`api/users/${this.userId}`);
      this.title = `${this.user.last_name} ${this.user.first_name}`;

      this.loading = false;
    },
    async deleteUser() {
      this.deleteButtonLoader = true;
      this.deleteConfirmVisible = false;
      try {
        await this.$store.dispatch('user/delete', this.user.id);
        this.$store.dispatch('user/fetchAll');
        this.$router.replace('/users');
      } catch (e) {
      }
      this.deleteButtonLoader = false;
    }
  },
};
</script>
